const atualizarModelos = (state, modelos) => {
    state.modelos = modelos;
}

const atualizarModelo = (state, modelo) => {
    state.modelo = modelo;
}

export default {
    atualizarModelos,
    atualizarModelo
}